<template >
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
  >
    <form>
      <b-row class="pb-1 pr-1">
        <b-col>
          <b-input
            id="cdBarra"
            maxlength="44"
            autofocus
            type="text"
            v-on:keyup.enter="onScan()"
            v-model="cd_barra"
            @contextmenu="handleWritingBarcodePermission($event)"
            @dragover="handleWritingBarcodePermission($event)"
            @paste="handleWritingBarcodePermission($event)"
            @drop="handleWritingBarcodePermission($event)"
            ref="cdBarra"
          ></b-input>
          <span>Qtde. caracteres código de barra: {{ qtdCaracteres() }}</span>
        </b-col>
        <b-col class="p-0">
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
            >Escanear código</b-btn
          >
        </b-col>
        <b-col md="4" style="display: flex; align-items: center">
          <span>Qtde. Ctes bipados / Quantidade de Ctes : </span>
          <h4 class="ml-1">
            {{ this.qtd_ctes_bipados_total }}/{{ this.qtd_ctes_total }}
          </h4>
        </b-col>
        <b-col class="p-0">
          <b-btn
            :disabled="loading"
            @click="onCancelBip()"
            style="
              background-color: #dc3545 !important;
              border: #dc3545 1px solid;
            "
            >Cancelar Bipagem</b-btn
          >
        </b-col>
      </b-row>
      <b-row class="pb-1 pr-1" v-for="(item, index) in redespachos" :key="item.cnpj">
        <b-col md="4" style="display: flex; align-items: center">
          <span>{{ item.nome }} - {{ ajustaMascara(item.cnpj) }}: </span>
          <h4 class="ml-1">{{ item.qtde_total_bip }}/{{ item.qtde_total }}</h4>
        </b-col>
      </b-row>
    </form>

    <div class="horizontal-scroll">
      <div class="loadingDataPosition">
        <div class="loadingData" v-if="loading"></div>
        <vuetable
          ref="vuetable"
          :api-mode="false"
          :data="documentos"
          :fields="fields"
          :css="css"
          :append-params="moreParams"
          :row-class="onRowClass"
          track-by="cargabipdoc_id"
          pagination-path=""
          @vuetable:load-error="onError"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded"
        >
          <template slot="status" slot-scope="props">
            <span class="badge badge-warning" v-if="props.rowData.status == 1"
              >Não checado</span
            >
            <span class="badge badge-success" v-if="props.rowData.status == 2"
              >Checado</span
            >
          </template>
          <template slot="redespacho" slot-scope="props">
            <span v-if="props.rowData.redespacho_cnpj"
              >{{ props.rowData.redespacho_nome }} -
              {{ ajustaMascara(props.rowData.redespacho_cnpj) }}
            </span>
          </template>
          <template slot="unidade_emissora" slot-scope="props">
            <span v-if="props.rowData.unidade"
              >{{ props.rowData.unidade }}
            </span>
          </template>
          <template slot="regiao_despesa" slot-scope="props">
            <span v-if="props.rowData.regiao_despesa != null"
              >{{ props.rowData.regiao_despesa.cd }} -
              {{ props.rowData.regiao_despesa.descr }}
            </span>
            <span v-if="props.rowData.regiao_despesa_rps != null">
              {{ props.rowData.regiao_despesa_rps.texto }}
            </span>
          </template>
        </vuetable>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="handleFechar()" variant="secondary"> Fechar </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import WritingBarcodePermission from '../mixins/WritingBarcodePermission';

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  mixins: [WritingBarcodePermission],
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      tp_fechar: false,
      permission: true,
      paste: false,
      modal_botao: "",
      modal_acao: "",
      loading: false,
      documentos: [],
      song: new Audio(),
      sucesso: require("../../public/audio/sucesso.mp3"),
      erro: require("../../public/audio/erro.mp3"),
      redespachos: [],
      permite_digitar: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      notas_fiscais: [],
      qtd_ctes_total: 0,
      qtd_ctes_bipados_total: 0,
      carga_id: "",
      cd_barra: "",
      num_carga: "",
      form: new Form({
        carga_id: "",
        cd_barra: "",
      }),
      helpForm: new Form({ search: "", carga_id: "" }),
      fields: [
        {
          name: "num_fiscal",
          title: "N° Fiscal",
        },
        {
          name: "chave",
          title: "Chave",
        },
        {
          name: "__slot:redespacho",
          title: "Redespacho",
        },
        {
          name: "__slot:unidade_emissora",
          title: "Unidade Emissora",
        },
        {
          name: "__slot:regiao_despesa",
          title: "Região",
        },
        {
          name: "usuario_bip",
          title: "Usuário Bip",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  created() {
    this.setPermissionToCheck('expedicao.digitaretiqueta');
  },
  methods: {
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onCreate(carga_id) {
      this.errors_array = "";
      this.errors_array = [];
      this.modal_titulo = "Checagem Carga";
      this.modal_botao = "Checagem Carga";
      this.modal_acao = "i";
      this.form.reset();
      this.documentos = [];
      this.redespachos = [];
      this.loading = true;
      this.isDisabled = true;
      this.tp_fechar = false;
      this.qtd_ctes_total = 0;
      this.qtd_ctes_bipados_total = 0;
      this.form.carga_id = carga_id;
      this.form
        .post("/api/expedicao/buscactecarga")
        .then((response) => {
          new ReturnApi(response, this);
          this.qtd_ctes_bipados_total = response.carga.qtd_ctes_bipados_total;
          this.qtd_ctes_total = response.carga.qtd_ctes_total;
          this.redespachos = response.redespachos;
          response.carga.carga_bip_doc_conf.forEach((item, i) => {
            var usuario_bip = "";
            if (item.usuario_bip && item.usuario_bip.pessoa.pessoa_fisica) {
              usuario_bip = item.usuario_bip.pessoa.pessoa_fisica.nome;
            } else if (
              item.usuario_bip &&
              item.usuario_bip.pessoa.pessoa_juridica
            ) {
              usuario_bip =
                item.usuario_bip.pessoa.pessoa_juridica.razao_social;
            }
            if (item.doc.doc_cte != null) {
              this.documentos.push({
                num_fiscal: item.doc.num_fiscal,
                chave: item.doc.doc_cte.chave,
                regiao_despesa: item.doc.regiao_despesa,
                usuario_bip: usuario_bip,
                unidade: item.doc.doc_cte_partes_env.emi_nome_fantasia,
                redespacho_cnpj:
                  item.doc.doc_carga_doc[0].carga_doc.doc_fiscal
                    .doc_fiscal_partes_env.red_cnpj,
                redespacho_nome:
                  item.doc.doc_carga_doc[0].carga_doc.doc_fiscal
                    .doc_fiscal_partes_env.red_nome,
                cargabipdocconf_id: item.cargabipdocconf_id,
                status: item.status,
              });
            }
            if (item.doc.doc_rps != null && item.doc.doc_cte == null) {
              this.documentos.push({
                num_fiscal: item.doc.num_fiscal,
                chave: item.doc.doc_rps.chave,
                regiao_despesa_rps: item.doc.doc_rps.doc_rps_regiao,
                usuario_bip: usuario_bip,
                unidade: item.doc.doc_cte_partes_env.emi_nome_fantasia,
                redespacho_cnpj:
                  item.doc.doc_carga_doc[0].carga_doc.doc_fiscal
                    .doc_fiscal_partes_env.red_cnpj,
                redespacho_nome:
                  item.doc.doc_carga_doc[0].carga_doc.doc_fiscal
                    .doc_fiscal_partes_env.red_nome,
                cargabipdocconf_id: item.cargabipdocconf_id,
                status: item.status,
              });
            }
          });

          this.form.documentos = this.documentos;
          this.qtde_ctes = this.documentos.length;
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });

      this.$refs.modal_form.show();
    },
    onScan(carga_id) {
      if (!this.cd_barra || this.cd_barra.trim() === "") {
        return;
      }
      this.errors_array = [];
      this.loading = true;
      this.isDisabled = true;
      this.form.cd_barra = this.cd_barra;
      this.form
        .post("/api/expedicao/bipcte")
        .then((response) => {
          new ReturnApi(response, this);
          this.tocaMusica(this.sucesso);
          this.qtd_ctes_bipados_total++;
          if (
            response.redespacho.cnpj != null &&
            this.redespachos[response.redespacho.cnpj] !== undefined
          ) {
            this.redespachos[response.redespacho.cnpj].qtde_total_bip++;
          }
          var documento_index = this.documentos.findIndex(
            (item) => item.chave == response.documento.chave
          );
          //Caso não encontre a função findIndex retorna -1
          if (documento_index !== -1) {
            this.documentos[documento_index].status = 2;
            this.documentos[documento_index].usuario_bip =
              response.usuario_bip.nome;
          }
          this.cd_barra = "";
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.tocaMusica(this.erro);
          this.errors_array = "";
          this.errors_array = [];
          this.cd_barra = "";
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
          this.$refs.cdBarra.$el.focus();
        });
    },
    onCancelBip() {
      var vm = this;
      var carga_id = this.form.carga_id;
      const onConfirmUnitWrapper = () => {
        confirmCancelFn(vm, carga_id);
      };

      let confirmCancelFn = function (vm, carga_id) {
        vm.form
          .post("/api/expedicao/cancelBipCte")
          .then((response) => {
            new ReturnApi(response, vm);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };

      let obj = {
        title: "Atenção!",
        message: "Deseja prosseguir com o cancelamento da bipagem?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    handleFechar() {
      this.showModal = false;
    },
    tocaMusica(musica) {
      this.song.pause();
      this.song.currentTime = 0;
      this.song.src = musica;
      this.song.play();
    },
    onRowClass(data) {
      if (data.status == 1) {
        return "table-warning";
      } else {
        return "table-success";
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    checkPermissionBip() {
      return this.getPermissionFw("montagemcarga.digitaretiqueta");
    },
    qtdCaracteres() {
      return this.cd_barra.length;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
  watch: {
    'cd_barra'(newValue, oldValue){
      this.handleWritingBarcodePermission(newValue, oldValue)
    }
  }
};
</script>
<style>
.horizontal-scroll {
  overflow-y: auto;
}
</style>